/**
 * @generated SignedSource<<0b095549fe7800762aebead8d12cd3ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentTakeoverAdSectionsAtomBase$data = {
  readonly __typename: "Article";
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "atomsCurrentTakeoverAdSectionsAtomBase";
} | {
  readonly __typename: "Section";
  readonly fullSectionPath: ReadonlyArray<{
    readonly entityId: string;
  } | null> | null;
  readonly " $fragmentType": "atomsCurrentTakeoverAdSectionsAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentTakeoverAdSectionsAtomBase";
};
export type atomsCurrentTakeoverAdSectionsAtomBase$key = {
  readonly " $data"?: atomsCurrentTakeoverAdSectionsAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentTakeoverAdSectionsAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentTakeoverAdSectionsAtomBase"
};

(node as any).hash = "b2c8778e7152d7b70cb532681ca11023";

export default node;
